// @flow

import { TREE } from '../constants'

export default (state: Object): Object => state[TREE].accountOperation
